import {Tailwind} from '@wandb/weave/components/Tailwind';
import React, {useState} from 'react';

import {WANDB_SYSTEM_AUTOMATION_NAME} from '../../utils';
import {Trigger} from './utilTypes';
import {ViewTriggerDrawer} from './ViewTriggerDrawer';

export const isViewTriggerDisabled = (trigger: Trigger) =>
  trigger.name === WANDB_SYSTEM_AUTOMATION_NAME;

type TriggerNameProps = {
  trigger: Trigger;
};

export const TriggerName = ({trigger}: TriggerNameProps) => {
  const [isViewTriggerDrawerOpen, setIsViewTriggerDrawerOpen] = useState(false);
  return (
    <Tailwind style={{height: '100%', width: '100%'}}>
      <div className="flex h-full flex-col items-start justify-center">
        {isViewTriggerDisabled(trigger) ? (
          <div className="self-start text-base font-semibold">
            {trigger.name}
          </div>
        ) : (
          <>
            <div
              className="cursor-pointer self-start text-base font-semibold text-teal-600 hover:text-teal-500"
              onClick={() => setIsViewTriggerDrawerOpen(true)}>
              {trigger.name}
            </div>
            {trigger.description}
          </>
        )}
      </div>
      <ViewTriggerDrawer
        open={isViewTriggerDrawerOpen}
        closeDrawer={() => setIsViewTriggerDrawerOpen(false)}
        trigger={trigger}
      />
    </Tailwind>
  );
};
